var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValvebox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3e4346",
    d: "M12,0A12,12,0,1,0,24,12,12.035,12.035,0,0,0,12,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5,5V19H19V5Zm7,7L6.1,17.9h0V6.1h0L12,12l5.9-5.9V17.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValvebox);
export default __webpack_public_path__ + "static/media/valvebox.09f66c1c0e50297efbc605b6b84d1cb8.svg";
export { ForwardRef as ReactComponent };